module.exports = new __parcel__URL__("space_elixir_mine_level_13.a0e8b9b9.png").toString();